import { ProductDto } from "@1games-ru/region-shared/dist/backend/requests/business";
import clsx from "clsx";
import formatPrice from "@/core/helpers/formatPrice";

type Props = {
  list: ProductDto[];
  price: number;
  isOdd?: boolean;
};

export default function PurchaseHistoryLog({ list, price, isOdd }: Props) {
  const purchase = list.map((item) => `${item.name} x${item.amount}`).join(", ");

  return (
    <div
      className={clsx(
        "flex justify-between items-start py-[0.6875rem] px-4 rounded-xl",
        !isOdd && "bg-dark-800",
      )}
    >
      <p className="text-15 font-medium text-white/70">{purchase}</p>
      <p className="text-15 font-bold text-accent-solid">+{formatPrice(price)}₽</p>
    </div>
  );
}
